export default __webpack_public_path__ + "media/images/icons_fc/tools-f771e5b49b91539dfb3ed0dab42bf6d5.png";